import LocalizedStrings from "react-localization";

export const TAB_NAMES = new LocalizedStrings({
  en: {
    myDashboard: "My Dashboard",
    teacherResources: "Teacher Hub",
    exercises: "Exercises",
    myLearnings: "My Learning",
    myProgress: "My Progress",
    homework: "Homework",
    tools: "Tools",
    teamDashboard: "Company Dashboard",
    adminDashboard: "Admin Dashboard",
    lessonCatalog: "Lesson Catalog",
    settings: "Account Settings",
    help: "Help Center",
    library: "Catalog",
    students: "Students",
    content: "Content",
    signIn: "Sign In",
    language: "Language",
    course: "Course",
    levelTest: "takeLvTest",
    retakeLevelTest: "retakeLvTest",
  },
  ko: {
    myDashboard: "My Dashboard",
    teacherResources: "Teacher Hub",
    exercises: "Exercises",
    myLearnings: "My Learning",
    myProgress: "My Progress",
    homework: "Homework",
    tools: "Tools",
    teamDashboard: "Team Dashboard",
    adminDashboard: "Admin Dashboard",
    lessonCatalog: "Lesson Catalog",
    settings: "Account Settings",
    help: "Help Center",
    library: "Catalog",
    students: "Students",
    content: "Content",
    signIn: "Sign In",
    language: "Language",
    course: "Course",
    levelTest: "takeLvTest",
    retakeLevelTest: "retakeLvTest",
  },
  de: {
    myDashboard: "My Dashboard",
    teacherResources: "Teacher Hub",
    exercises: "Exercises",
    myLearnings: "My Learning",
    myProgress: "My Progress",
    homework: "Homework",
    tools: "Tools",
    teamDashboard: "Team Dashboard",
    adminDashboard: "Admin Dashboard",
    lessonCatalog: "Lesson Catalog",
    settings: "Account Settings",
    help: "Help Center",
    library: "Catalog",
    students: "Students",
    content: "Content",
    signIn: "Sign In",
    language: "Language",
    course: "Course",
    levelTest: "takeLvTest",
    retakeLevelTest: "retakeLvTest",
  },
  es: {
    myDashboard: "My Dashboard",
    teacherResources: "Teacher Hub",
    exercises: "Exercises",
    myLearnings: "My Learning",
    myProgress: "My Progress",
    homework: "Homework",
    tools: "Tools",
    teamDashboard: "Team Dashboard",
    adminDashboard: "Admin Dashboard",
    lessonCatalog: "Lesson Catalog",
    settings: "Account Settings",
    help: "Help Center",
    library: "Catalog",
    students: "Students",
    content: "Content",
    signIn: "Sign In",
    language: "Language",
    course: "Course",
    levelTest: "takeLvTest",
    retakeLevelTest: "retakeLvTest",
  },
});
